var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFundcomb = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    stroke: "#22262A",
    strokeWidth: 0.04,
    d: "M8.626 17.141H5.5V8.797h6.252v2.646H8.626v.917h2.521v2.459h-2.52zM20.5 9.988l-1.436 2.184c-.937-.71-2.02-.98-2.831.122-.215.29-.155 1.02 0 1.294.586 1.037 1.829 1.022 2.831.202l1.436 2.245c-.412.386-.665.657-1.436.95-1.957.746-3.974.288-5.177-1.071-1.88-2.124-1.187-5.385.85-6.593 2.143-1.272 4.933-.527 5.763.667Z"
  })));
};
export default SvgFundcomb;